import { render, staticRenderFns } from "./ChurnDescriptionPopup.vue?vue&type=template&id=0f67c944&scoped=true&"
import script from "./ChurnDescriptionPopup.vue?vue&type=script&lang=js&"
export * from "./ChurnDescriptionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67c944",
  null
  
)

export default component.exports